<template>
  <div id="app" class="app-root" :class="{glorious:isGlorious}">
    <rotate-overlay v-if="inPWAView"></rotate-overlay>
    <export v-if="inExportView"></export>
    <header v-if="!inExportView">
      <top-nav></top-nav>
    </header>
    <div class="container" v-if="!inExportView">
      <div class="row justify-content-md-center main-content">
        <div class="col-md-10">
          <transition name="page">
              <router-view></router-view>
          </transition>
        </div>
      </div>
    </div>

    <div class="container-fluid footer" v-if="!inAppWebView && !inExportView">
      <div class="row justify-content-md-center default-color">
        <div class="col-md-10 text-center">
          <div class="footer-wraper">
            COPYRIGHT © {{Year}} {{ CompanyName }} LIMITED <br>
            <span>如有任何使用上的問題，歡迎 Email 至 <a href="mailto:cs.mm-chat@mixmedia.com">cs.mm-chat@mixmedia.com</a></span>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import Export from "@/views/Export";
import TopNav from "./components/TopNav";
import WSService from "./Services/WSService";
import UserService from "./Services/UserService";
import MsgServiceClass from "@/Services/MsgService";
import OnesignalService from "./Services/onesignalService";
import {isBizChatApp} from "./utils/detect";
import AppService from "./Services/AppService";
import badgeService from "./Services/badgeService";
import {WebClipDetect} from "@/Services/pwaService";
import {addContact} from "@/store/contactsStore";
import dayjs from "dayjs";
import RotateOverlay from "./components/rotate-overlay.vue";
import { EventBus } from "./Bus.js";

let ws = WSService.getInstance();
const MsgService = new MsgServiceClass();

export default {
  components: {
    "top-nav": TopNav,
    "rotate-overlay":RotateOverlay,
    Export,
  },
  data() {
    return {
      contactListUpdateTime: 0,
      state: {
        user: false
      },
      fromID: 0,
      currentUnreadCount:0,
    };
  },

  watch: {
    inContactsView(val) {
      if (val) {
        this.refreshContacts();
      }
    }
  },

  computed:{
    CompanyName() {
      if (this.isGlorious) {
        return "WWW.GLORIOUS.HK"
      }
      return "DRIVER.COM.HK"
    },
    isGlorious() {
      return global.NAMESPACE === "glorious";
    },
    Year() {
      return (new Date()).getFullYear();
    },
    inAppWebView() {
      return isBizChatApp();
    },
    inContactsView() {
      return this.$route.name === "contacts";
    },
    inPWAView(){
      return WebClipDetect.isPWA();
    },
    inExportView() {
      return this.$route.name === "export";
    }
  },

  methods: {
    detectUpgrade() {
      return AppService.detectUpgrade();
    },
    showLogin() {
      //获取当前url，login后跳回
      const refURL = this.$route.fullPath;
      //如果已经在login view，不需要继续跳转
      if (!["login", "jsbridge"].includes(this.$route.name)) {
        this.$router.push({
            name: "login",
            query: {
                ref: encodeURI(refURL)
            }
        });
      }
    },
    showContacts() {
      this.$router.push({
        path:'/'
      });
    },

    handleSubscribeNotification() {
      this.contactListUpdateTime = Date.now();
      this.firstFetchContacts();
      (new UserService).me(true).then((data) => {
        ws.connect();
        return OnesignalService.subscribe(data.subscribed);
      })
    },
    handleOnesignalTokenExpired() {
      return OnesignalService.subscribe('');
    },
    refreshContacts() {
      // 刷新联系人列表 缓存 5分钟
      if ((Date.now() - this.contactListUpdateTime) > (5 * 60 * 1000)) {
        this.firstFetchContacts()
            .then(() => {
              this.contactListUpdateTime = Date.now();
            });
      }
    },
    firstFetchContacts() {
      return (new UserService).users({refresh: true});
    },

    handlePWAReOpen() {
      /**
       * PWA 模式下防止 ws 被掛起
       * 重新進入時重刷頁面
       */
      if (WebClipDetect.isPWA()
          && !ws.isActive()
      && this.$route.name != "login") {
        location.reload();
      }
    }
  },

  mounted() {
    this.detectUpgrade();
    this.handleSubscribeNotification();
  },

  created() {
    window.addEventListener("focus", this.handlePWAReOpen);
    EventBus.onUserAuthError(this.showLogin);
    EventBus.onUserLogin(this.handleSubscribeNotification);
    EventBus.onMarkedAllAsRead(badgeService.clear);
    EventBus.onContactUpdated((event) => {
      if (this.$route.params?.uid != event.fromData.uid) {
        badgeService.add(event.fromData.uid);
        let time = event.time && dayjs.unix(event.time).format("YYYY-MM-DD HH:mm:ss") || '';
        addContact({
          ...event.fromData,
          time,
          unread: 1,
        });
      } else {
        MsgService.read(event.fromData.uid);
      }
      this.refreshContacts();
    });
    EventBus.onOneSignalTokenExpired(this.handleOnesignalTokenExpired);
  },
  beforeDestroy() {
    ws.close();
    window.removeEventListener("focus", this.handlePWAReOpen);
  }
};
</script>
<style lang="css" src="bootstrap-css-only/css/bootstrap.css"></style>
<style lang="css" src="./assets/iconfont/iconfont.css"></style>
<style lang="scss" src="mdbvue/build/scss/mdb.lite.scss"></style>
<style lang="scss" src="./style/main.scss"></style>


